import { Layout } from 'antd';
import { Toolbar } from './toolbar/Toolbar';
import { Sidebar } from './sidebar/Sidebar';
import { Canvas } from './canvas/Canvas';
import { PropsPanel } from './panel/PropsPanel';
import { PreviewModal } from './preview/PreviewModal';
import { useShortcuts } from './hooks/useShortcuts';
import { usePersistence } from './hooks/usePersistence';
import { AuthModal } from './api/AuthModal';
import { TemplatePicker } from './templates/TemplatePicker';

export function App() {
  useShortcuts();
  const { save } = usePersistence();
  return (
    <Layout style={{ height: '100vh' }}>
      <Toolbar onSave={save} />
      <Layout style={{ flex: 1, minHeight: 0 }}>
        <Layout.Sider width={260} theme="light" style={{ borderRight: '1px solid #f0f0f0', overflow: 'auto' }}>
          <Sidebar />
        </Layout.Sider>
        <Layout.Content style={{ display: 'flex', minWidth: 0 }}>
          <Canvas />
        </Layout.Content>
        <Layout.Sider width={300} theme="light" style={{ borderLeft: '1px solid #f0f0f0', overflow: 'auto' }}>
          <PropsPanel />
        </Layout.Sider>
      </Layout>
      <PreviewModal />
      <AuthModal />
      <TemplatePicker />
    </Layout>
  );
}
